(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5376],{

/***/ 96286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        yourCart: t("kf.cart.label.yourCart"),
        emptyCart: t("kf.cart.label.emptyCart"),
        sharCartLink: t("kf.cart.label.sharCartLink"),
        sharCartLinkCopied: t("kf.cart.label.sharCartLinkCopied"),
        qty: "Quantity",
        unitPrice: t("kf.cart.label.unitPrice"),
        total: "Total",
        colorFinish: t("kf.cart.label.colorFinish"),
        inStockMsg: t("kf.cart.label.inStockMsg"),
        saveLater: t("kf.cart.label.saveLater"),
        remove: t("kf.cart.label.remove"),
        continueCheckout: t("kf.cart.label.continueCheckout"),
        orderSummary: t("kf.cart.label.orderSummary"),
        LoadCart: t("Kf.button.action.loadcart"),
        collabrativeCartDecs: t("kf.cart.label.collbcartdecs"),
        createcart: t("kf.cart.lable.createcart"),
        customersCartID: t("kf.cart.lable.customercartid"),
        or: t("kf.cart.lable.or"),
        subTotal: t("kf.cart.label.subTotal"),
        MRPSubtotal: t("kf.cart.label.MRPSubtotal"),
        totalPromotions: t("kf.cart.label.totalPromotions"),
        estimatedShipping: t("kf.cart.label.estimatedShipping"),
        estimatedTax: t("kf.cart.label.estimatedTax"),
        estimatedTotal: t("kf.cart.label.estimatedTotal"),
        enterPromo: t("kf.cart.label.enterPromo"),
        coupon: t("kf.cart.label.coupon"),
        apply: t("kf.global.label.apply"),
        free: t("kf.cart.label.free"),
        freeShipping: t("kf.label.freeShipping"),
        previousDiscountErr: t("kf.cart.error.previousDiscountErr"),
        combinePromoErr: t("kf.cart.error.combinePromoErr"),
        maxAppReachedErr: t("kf.cart.error.maxAppReachedErr"),
        promoNotApplicable: t("kf.cart.error.promoNotApplicable"),
        invalidPromoErr: t("kf.cart.error.invalidPromoErr"),
        noPromoErr: t("kf.cart.error.noPromoErr"),
        update: t("kf.global.label.update"),
        zipCode: t("kf.cart.label.zipCode"),
        edit: t("kf.cart.label.edit"),
        cart: t("kf.cart.label.cart"),
        shareCart: t("kf.cart.label.shareCart"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        downloadSpecs: t("kf.cart.label.downloadSpecs"),
        noItemsInCart: "Your Cart is Empty ",
        addA: t("kf.cart.label.addA"),
        or: t("kf.global.label.or"),
        recentlyViewedItem: t("kf.cart.label.recentlyViewedItem"),
        recentlyViewedTitle: t("kf.cart.label.recentlyViewedTitle"),
        recentlyViewedColor: t("kf.pairsWellWith.label.color"),
        recentlyViewedColors: t("kf.pairsWellWith.label.colors"),
        ariaLabelColor: t("kf.pairsWellWith.aria.colors"),
        ariaLabelTooltip: t("kf.pairsWellWith.aria.tooltip"),
        continueShopping: "Continue Shopping",
        alert: t("kf.global.label.alert"),
        outOfStock: t("kf.cart.label.outOfStock"),
        outOfStockAlert: t("kf.cart.label.outOfStockAlert"),
        cannotShip: t("kf.cart.label.cannotShip"),
        callSupport: t("kf.cart.label.callSupport"),
        needMoreTime: t("kf.cart.label.needMoreTime"),
        saveCartMssg: t("kf.cart.label.saveCartMssg"),
        createAccount: t("kf.cart.label.createAnAccount"),
        createCartAccount: t("kf.cart.label.createCartAccount"),
        saveYourCart: t("kf.cart.label.saveYourCart"),
        taxTooltip: t("kf.cart.label.taxTooltip"),
        shippingTooltip: t("kf.cart.label.shippingTooltip"),
        oversizedDelivery: t("kf.cart.label.oversizedDelivery"),
        oversizedFragileDelivery: t("kf.cart.label.oversizedFragileDelivery"),
        freightShipping: t("kf.orderDetails.label.freightShipping"),
        freightLabel: t("kf.orderSUmmary.label.freightLabel"),
        validZipcode: t("kf.checkout.error.validZipcode"),
        zipCodeError: t("kf.checkout.error.zipcodeError"),
        note: t("kf.cart.label.note"),
        comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
        outOfStockToolTip: t("kf.cart.label.outOfStockToolTip"),
        qtyMoreThanToolTip: t("kf.cart.label.qtyMoreThanToolTip"),
        noShippingTooltip: t("kf.cart.label.noShippingTooltip"),
        emptyCartAria: t("kf.cart.label.emptyCartAria"),
        continueCheckoutAria: (count, total)=>t("kf.cart.label.continueCheckoutAria", {
                count: count,
                total: total
            }),
        removePromoAria: t("kf.cart.label.removePromoAria"),
        shippingInfoAria: t("kf.cart.label.shippingInfoAria"),
        strikedPrice: t("kf.cart.label.strikedPrice"),
        taxInfoAria: t("kf.cart.label.taxInfoAria"),
        discountPercentage: t("kf.checkout.label.discountPercentage"),
        productDiscounts: t("kf.cart.label.productDiscounts"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        off: t("kf.cart.label.off"),
        linearFtNeeded: t("annsacks.pdpTrimCalculator.label.linearFtNeeded"),
        squareFtNeeded: t("annsacks.pdpTrimCalculator.label.squareFtNeeded"),
        overage: t("annsacks.pdpTrimCalculator.label.overage"),
        lf: t("annsacks.pdpTrimCalculator.label.LF"),
        sf: t("annsacks.pdpTrimCalculator.label.SF"),
        totalLF: t("annsacks.pdpTrimCalculator.label.totalLF"),
        totalSF: t("annsacks.pdpTrimCalculator.label.totalSF"),
        pieces: t("annsacks.pdpTrimCalculator.label.pieces"),
        boxes: t("annsacks.pdpTrimCalculator.label.boxes"),
        totalPieces: t("annsacks.pdpTrimCalculator.label.totalPieces"),
        totalBoxes: t("annsacks.pdpTrimCalculator.label.totalBoxes"),
        whatYouWillReceive: t("annsacks.pdpTrimCalculator.label.whatYouWillReceive"),
        totalCoverage: t("annsacks.pdpTrimCalculator.label.totalCoverage"),
        cartLandingCalculatorTitle: t("annsacks.pdpTrimCalculator.label.cartLandingCalculatorTitle"),
        cartLandingCalculatorDescription: t("annsacks.pdpTrimCalculator.label.cartLandingCalculatorDescription"),
        cartLandingCalculatorArea: t("annsacks.pdpTrimCalculator.label.area"),
        cartLandingCalculatorRecalculate: t("annsacks.pdpTrimCalculator.label.recalculate"),
        qtyMoreThanStock: (stock, qty)=>t("kf.cart.label.qtyMoreThanStock", {
                qty,
                stock
            }),
        yourSharedCartID: (cartNumber)=>t("kf.share.label.yourSharedCartID", "Cart ID:", {
                cartNumber
            }),
        recalculateUpdateCart: t("annsacks.recalculate.label.updateCart"),
        recalculateLinearFt: t("annsacks.recalculate.label.linearFt"),
        recalculateSqureFt: t("annsacks.recalculate.label.squreFt"),
        mailSubject: t("kf.share.label.emailSubject"),
        noItemsToShip: t("kf.cart.label.noItemsToShip"),
        availableToShip: t("kf.cart.label.availableToShip"),
        removeDiscountErrorMsg: t("kf.cart.label.removeDiscountErrorMsg"),
        qtyMinus: "Quantity minus",
        qtyPlus: "Quantity plus",
        profileFailure: t("kf.account.label.profileFailure"),
        signIn: t("kf.loggedin.button.signIn"),
        needHelpOrder: t("kf.cart.label.needHelpOrder"),
        promocode: t("kf.cart.label.promocode"),
        signInItemsPreviously: "Sign in to see items previously added to your cart",
        iscUserLoadMessage: t("kf.cart.label.iscUserLoadMessage"),
        abandonedCarts: t("kf.cart.label.abandonedCarts"),
        proceedToCheckout: t("kf.cart.label.proceedToCheckout"),
        item: "Item",
        itemPrice: "Item Price",
        itemDiscount: t("kf.cart.label.itemdiscount"),
        couponDiscount: t("kf.cart.label.coupondiscount"),
        calculatedInCheckout: t("kf.cart.label.calculatedInCheckout"),
        tax: t("kf.ordersummary.label.tax"),
        shipping: t("kf.list.table.shipping"),
        saveAddressMyAccount: t("kf.checkout.label.saveAddressMyAccount"),
        inStock: t("kf.cart.label.inStock"),
        checkout: t("kf.cart.label.checkout"),
        expirePromoErr: t("kf.cart.error.ExpirePromoErr"),
        standardShipping: t("kf.cart.label.standardshipping"),
        fragileDelivery: t("kf.cart.label.fragileDelivery"),
        continueToDelivery: t("kf.cart.label.continueToDelivery"),
        outOfStock: t("kf.cart.label.inventory.outOfStock"),
        cartAlert: t("kf.cart.label.inventory.cartAlert"),
        maxStock: (quantity)=>"Only ".concat(quantity, " items available in stock. Please update the quantity to proceed."),
        bundleOutOfStock: t("kf.cart.label.inventory.bundleOutOfStock"),
        partialBundleOutOfStock: t("kf.cart.label.inventory.partialBundleOutOfStock"),
        includingintaxes: t("kf.cart.label.includingintaxes"),
        includingPriceInTaxes: (price)=>t("kf.cart.label.includingPriceInTaxes", {
                price
            }),
        including: t("kf.cart.label.including"),
        InTaxes: t("kf.cart.label.InTaxes"),
        customerCart: t("kf.cart.label.customerCart"),
        copyCartId: t("kf.cart.label.copyCartId"),
        checkoutAsCustomer: t("kf.cart.label.checkoutAsCustomer"),
        customerInformation: t("kf.orderDetails.label.customerInfo"),
        name: t("kf.account.label.name"),
        email: t("kf.share.label.email"),
        mobileNumber: t("kf.profile.title.mobileNumber"),
        address: t("kf.contactus.label.address"),
        contactCustomer: t("kf.cart.label.contactCustomer"),
        howToContact: t("kf.contactCustomer.label.howToContact"),
        phone: t("kf.checkout.label.phone"),
        notRecovered: t("kf.abandonedCart.label.notRecovered"),
        removeAbandonedCart: t("kf.abandonedCart.label.removeAbandonedCart"),
        removeAbandonedCartSuccess: t("kf.abandonedCart.label.removeAbandonedCartSuccess"),
        removeAbandonedCartConfirm: t("kf.abandonedCart.label.removeAbandonedCartConfirm"),
        close: t("kf.checkout.label.close"),
        yes: t("kf.keyspecifier.label.yes"),
        no: t("kf.keyspecifier.label.no"),
        backToTop: t("kf.favorite.label.backToTop"),
        view: "View",
        all: "All",
        loadMore: "Load More",
        sku: t("kf.cart.label.sku"),
        bundle: t("kf.plp.bundle"),
        showMore: t("kf.cart.showMore"),
        hideMore: t("kf.cart.hideMore"),
        items: t("kf.plp.items"),
        totalDiscount: t("kf.order-confirmation.totalDiscount"),
        mergeWithCart: "Merge with My Cart",
        addToMyCart: t("kf.cart.label.addToMyCart", "Add To Cart"),
        installServiceNotAvailable: t("kf.cart.label.installServiceNotAvailable"),
        removeFromCart: t("kf.cart.label.removeFromCart"),
        nonDeliverableMsg: t("kf.cart.label.nonDeliverableMsg"),
        updateCartForDeliveryAlert: t("kf.cart.alert.updateCartForDeliveryAlert"),
        reviewCart: t("kf.cart.alert.reviewCart"),
        noCostEMIMessage: t("kf.cart.label.noCostEMIMessage"),
        noCostEmiAvailable: t("kf.cart.label.noCostEmiAvailable"),
        availNoCostEmi: (amountLeft)=>t("kf.cart.label.availNoCostEmi", amountLeft),
        etaInformation: (minDay, maxDay)=>t("kf.checkout.shippingDetail.etaInformation", {
                minDay,
                maxDay
            }),
        cartUpdatedMessage: t("kf.cart.message")
    };
};


/***/ }),

/***/ 75376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PairsWellWith_PairsWellWith; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./components/cart/localization.js
var localization = __webpack_require__(96286);
// EXTERNAL MODULE: ./components/productCard/v1/ProductCard.view.jsx
var ProductCard_view = __webpack_require__(27221);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./src/components/PairsWellWith/index.module.scss
var index_module = __webpack_require__(77924);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/productCard/v1/analytics.js
var analytics = __webpack_require__(41740);
;// CONCATENATED MODULE: ./src/components/PairsWellWith/PairsWellWith.view.jsx









const PairsWellWithView = (param)=>{
    let { pairsProductProps , currencySign , presetConfigs , swatchUrl , source , title  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [staticText] = (0,react.useState)((0,localization/* getTranslations */.F)(t));
    const { COMPONENT  } = constants["default"];
    (0,react.useEffect)(()=>{
        const scrollDiv = document.querySelector(".pairs-well-with__carousel");
        if (scrollDiv) {
            scrollDiv.addEventListener("mousedown", (e)=>{
                const horizontalCoordinate = e.offsetX;
                const verticalCoordinate = e.offsetY;
                e.stopPropagation();
                if (!e.scrollClicked && horizontalCoordinate >= 30 && verticalCoordinate >= 563) {
                    (0,analytics/* getMoreInCollectionSlider */.Ag)(title !== null && title !== void 0 ? title : "");
                    e.scrollClicked = false;
                }
            }, true);
        }
        return ()=>{
            if (scrollDiv) {
                scrollDiv.removeEventListener("mousedown");
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pairsWellWithModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pairs-well-with pairs-well-with--recommended-product ".concat(source === "recently-viewed" ? "--recently-viewed" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ml-0 mr-0",
                        children: (pairsProductProps === null || pairsProductProps === void 0 ? void 0 : pairsProductProps.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 pairs-well-with__title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                "aria-level": "3",
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ml-0 mr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 pairs-well-with__carousel",
                            children: (pairsProductProps === null || pairsProductProps === void 0 ? void 0 : pairsProductProps.length) > 0 && pairsProductProps.map((product, i)=>/*#__PURE__*/ (0,react.createElement)(ProductCard_view/* default */.Z, {
                                    i18n: staticText,
                                    ...product,
                                    product: product,
                                    key: i,
                                    currencySign: currencySign,
                                    presetConfigs: presetConfigs,
                                    swatchUrl: swatchUrl,
                                    parent: COMPONENT.PAIRS_WELL_WITH,
                                    title: title
                                }))
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PairsWellWith_view = (PairsWellWithView);

// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
;// CONCATENATED MODULE: ./src/components/PairsWellWith/PairsWellWith.jsx













const PairsWellWith = (props)=>{
    var ref;
    const info = (0,react.useRef)({});
    const { cart: activeCart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { pdp: { sku: skuId = "" , recommendedAccessories =[] , productBrand ="" , productNo =""  } = {}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const { data: pairsWellWithdata = {} , data: { aemDataList =[] , dataFrom =null , mboxIdList =[] , title ="" , presetConfigs ="" , swatchUrl =""  } = {}  } = props;
    const initialState = {
        productRecommendedId: [],
        productData: [],
        pairsProductProps: [],
        ProductCategory: "",
        productName: "",
        source: null,
        brandName: ""
    };
    const [dataSource, setDataSource] = (0,react.useState)(null);
    const [state, setState] = (0,react.useState)(initialState);
    const [recommendedAccessoriesLocal, setRecommendedAccessoriesLocal] = (0,react.useState)([]);
    const [productBrandLocal, setProductBrandLocal] = (0,react.useState)("");
    const fetchFromTarget = async (mboxes, sku)=>{
        // TODO: GBH-16163 Update to use APIM Endpoint
        for(let i = 0; i < mboxes.length; i++){
            try {
                var ref, ref1;
                const res = await api/* apim.get */.TH.get("search/target-recommendations", {
                    params: {
                        mboxid: mboxes[i],
                        sku: sku
                    }
                });
                if (res && ((ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.recommendedItems) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                    const skus = res.data.recommendedItems.map((product)=>{
                        if (product.sku) {
                            return product.sku.replace("K-", "");
                        }
                    });
                    if (skus.length > 0) {
                        const productData = await (0,shareCartHelper/* getProductsBySku */.uX)(skus);
                        setState({
                            ...state,
                            productData
                        });
                    }
                    break;
                }
            } catch (err) {
                console.error(err);
            }
        }
    };
    const fetchRecentlyViewed = async ()=>{
        var ref;
        const viewedItems = localStorage.getItem("recently-viewed") ? JSON.parse(localStorage.getItem("recently-viewed")) : [];
        if ((viewedItems === null || viewedItems === void 0 ? void 0 : viewedItems.length) > 0 && (viewedItems === null || viewedItems === void 0 ? void 0 : viewedItems.length) >= ((ref = info.current) === null || ref === void 0 ? void 0 : ref.recentlyViewedMin)) {
            const productData = [];
            const products = await (0,cartHelper/* getProductsById */.OA)(viewedItems);
            // Pushing into new array to maintain recently viewed order
            viewedItems.forEach((id)=>{
                const product = products.find((p)=>p.id === id);
                if (product) {
                    productData.push(product);
                }
            });
            setState({
                ...state,
                productData
            });
        }
    };
    const getRecommendedProducts = (productNo)=>{
        const { recommendedSkus =[]  } = aemDataList.find((e)=>e.primarySku.includes(productNo)) || {};
        if (dataFrom === "fromAem" && recommendedSkus.length) {
            (0,shareCartHelper/* getProductsBySku */.uX)(recommendedSkus).then((productData)=>{
                setState({
                    productData,
                    recommendedSkus
                });
            });
        } else {
            setState({
                productData: [],
                recommendedSkus
            });
        }
    };
    const displayComponent = function() {
        let productlength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (!productlength) {
            return false;
        }
        if (dataSource === "recently-viewed") {
            var ref, ref1, ref2;
            if ((activeCart === null || activeCart === void 0 ? void 0 : (ref = activeCart.lineItems) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = state.productData) === null || ref1 === void 0 ? void 0 : ref1.length) >= ((ref2 = info.current) === null || ref2 === void 0 ? void 0 : ref2.recentlyViewedMin)) return true;
            return false;
        }
        return true;
    };
    const createPairsData = async ()=>{
        const pairsProductProps = [];
        state.productData.forEach((product)=>{
            const pData = {};
            (0,config/* getConfig */.i)().then(async (config)=>{
                const { general  } = config;
                var _pagePathPDP;
                pData.pdpUrl = await (0,helper.getShortenedUrl)((_pagePathPDP = general.pagePathPDP) !== null && _pagePathPDP !== void 0 ? _pagePathPDP : "/");
            });
            const masterVariant = get_default()(product, "masterVariant", []);
            const attributes = get_default()(masterVariant, "attributes", []);
            pData.name = get_default()(attributes.find((attr)=>attr.name === "ProductBrandName"), "value", "");
            pData.slug = get_default()(product, "slug[".concat(info.current.locale, "]"), "");
            pData.description = get_default()(product, "description[".concat(info.current.locale, "]"), "");
            pData.variants = get_default()(product, "variants", []);
            pData.colors = [];
            pData.variants.forEach((variant)=>{
                const discountinuedDate = get_default()(variant.attributes.find((attrib)=>attrib.name === "RegionDiscontinuedDate"), "value", "");
                if (!discountinuedDate || Date.parse(discountinuedDate) > Date.now()) {
                    pData.colors.push(variant);
                }
            });
            pData.sku = get_default()(masterVariant, "sku", "");
            pData.productCategory = get_default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", "");
            if (masterVariant.images && masterVariant.images.length > 0) pData.images = get_default()(masterVariant, "images[0].url", "");
            else pData.images = image_missing/* default */.Z;
            const priceObj = masterVariant.prices.find((item)=>{
                var ref, ref1;
                return item.value.currencyCode === info.current.currencyCode && ((ref = item.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) === info.current.persona;
            });
            pData.price = (Number(get_default()(priceObj, "value.centAmount", 0)) / 100).toFixed(2);
            pData.discountedPrice = (Number(get_default()(priceObj, "discounted.value.centAmount", 0)) / 100).toFixed(2);
            pairsProductProps.push(pData);
        });
        setState({
            ...state,
            pairsProductProps
        });
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const siteName = get_default()(config, "general.siteName", "");
            const persona = (0,helper.getUserPersona)();
            const recentlyViewedMin = get_default()(config, "general.recentlyViewedMin", 1);
            info.current = {
                locale: locale,
                currencyCode: currencyCode,
                currencySign: currencySign,
                recentlyViewedMin: recentlyViewedMin,
                siteName: siteName,
                persona: persona
            };
        });
    }, []);
    (0,react.useEffect)(()=>{
        setState({
            source: dataFrom,
            mbox: mboxIdList
        });
        setDataSource(dataFrom);
    }, [
        pairsWellWithdata
    ]);
    (0,react.useEffect)(()=>{
        if (skuId && aemDataList && aemDataList.length) getRecommendedProducts(productNo, skuId);
    }, [
        skuId,
        aemDataList,
        productNo
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (dataSource === "ct") {
            if (recommendedAccessoriesLocal.length) {
                (0,cartHelper/* getProductsById */.OA)(recommendedAccessoriesLocal).then((productData)=>setState({
                        ...state,
                        productData,
                        brandName: productBrandLocal
                    }));
            }
        } else if (dataSource === "mbox") {
            fetchFromTarget(state.mbox, skuId);
        } else if (dataSource === "recently-viewed" && (activeCart === null || activeCart === void 0 ? void 0 : (ref = activeCart.lineItems) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            fetchRecentlyViewed();
        }
    }, [
        activeCart,
        skuId,
        recommendedAccessoriesLocal,
        productBrandLocal,
        dataSource
    ]);
    (0,react.useEffect)(()=>{
        if (recommendedAccessories && recommendedAccessories.length > 0) {
            setRecommendedAccessoriesLocal(recommendedAccessories);
        }
    }, [
        recommendedAccessories
    ]);
    (0,react.useEffect)(()=>{
        if (productBrand) {
            setProductBrandLocal(productBrand);
        }
    }, [
        productBrand
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((ref = state.productData) === null || ref === void 0 ? void 0 : ref.length) createPairsData();
    }, [
        state.productData
    ]);
    return displayComponent((ref = state.productData) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PairsWellWith_view, {
        pairsProductProps: state.pairsProductProps,
        source: dataSource,
        title: title ? title.replace("{{category}}", state.brandName) : "",
        currencySign: info.current.currencySign,
        presetConfigs: presetConfigs,
        swatchUrl: swatchUrl
    });
};
/* harmony default export */ var PairsWellWith_PairsWellWith = (PairsWellWith);


/***/ }),

/***/ 77924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pairsWellWithModalWrapper":"PairsWellWith_pairsWellWithModalWrapper__PvKBd"};

/***/ })

}]);